module.exports = __webpack_public_path__ + "static/img/fuzhoumajiang.4af46ba.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/gameImg/fuzhoumajiang.jpg
// module id = 474U
// module chunks = 0